"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterAutocompleteCellFactory = void 0;
const common_types_1 = require("../../../common-types");
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const autocomplete_1 = require("../../../components/autocomplete/autocomplete");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
/**
 * info: I am not sure, why the is the codepath for multiple support, when the is no way to enable it
 *
 */
function useFilterAutocompleteCellFactory(dataHook, labelMapper, freeSolo) {
    const Cell = (0, react_1.useMemo)(() => function FilterAutocompleteCell({ disabled, state, filter, onChangeState, }) {
        const source = dataHook();
        const handleChange = (0, event_callback_hook_1.useEventCallback)((value) => {
            if ((0, lodash_1.isArray)(value)) {
                onChangeState({
                    ...state,
                    operation: common_types_1.ApiFilterOperation.AND,
                    filters: constructNestedFilters(filter.filterkey, value),
                    object: value,
                });
            }
            else {
                if (freeSolo) {
                    onChangeState({
                        ...state,
                        operation: common_types_1.ApiFilterOperation.CONTAINS,
                        value: value,
                    });
                }
                else {
                    onChangeState({
                        ...state,
                        operation: common_types_1.ApiFilterOperation.EQ,
                        value: value === null || value === void 0 ? void 0 : value.id,
                        object: value,
                    });
                }
            }
        });
        return (react_1.default.createElement(autocomplete_1.Autocomplete, { disabled: disabled, source: source, labelMapper: labelMapper, value: state.object, onChange: handleChange, freeSolo: freeSolo }));
    }, [dataHook]);
    Cell.source = dataHook();
    return Cell;
}
exports.useFilterAutocompleteCellFactory = useFilterAutocompleteCellFactory;
function constructNestedFilters(field, array) {
    return (array !== null && array !== void 0 ? array : []).map((o) => ({
        field: field,
        operation: common_types_1.ApiFilterOperation.EQ,
        value: o.id,
    }));
}
//# sourceMappingURL=filter-autocomplete-cell.js.map